import type { Reference, StoreObject } from '@apollo/client'
import { useMutation } from '@apollo/client'
import { Button, Tooltip, X } from '@chain-zen/ui'
import { toast } from 'sonner'

import { REMOVE_EXTERNAL_TRACKING_SOURCE } from '../../../data/mutations/tracking'

interface IRemoveTrackingURLProps {
  shipmentID: string
  trackingURL: string
}

/**
 * RemoveTrackingLink renders a cross icon. When clicked, it removes the tracking link.
 */
export const RemoveTrackingLink = (props: IRemoveTrackingURLProps) => {
  const { shipmentID, trackingURL } = props

  // Mutation to remove the tracking URL
  const [removeExternalTrackingSource] = useMutation(REMOVE_EXTERNAL_TRACKING_SOURCE, {
    onCompleted: () => {
      toast.success('Tracking link removed successfully.')
    },
    onError: (error) => {
      toast.error(error.message || 'Something went wrong.')
    },
    update(cache) {
      cache.modify({
        fields: {
          trackingSources(trackingSources, { readField }) {
            return trackingSources?.data?.filter(
              (trackingSource: { metadata: Reference | StoreObject | undefined }) =>
                trackingURL !== readField('url', trackingSource?.metadata)
            )
          }
        }
      })
    }
  })

  // Remove the tracking URL
  const handleRemoveTrackingLink = () => {
    const input = {
      shipmentID,
      url: trackingURL
    }

    removeExternalTrackingSource({ variables: input })
  }

  return (
    <Tooltip content="Remove this tracking link">
      <div>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleRemoveTrackingLink}>
          <X className="h-4 w-4 text-destructive" />
          <span className="sr-only">Remove tracking link</span>
        </Button>
      </div>
    </Tooltip>
  )
}
